import { createApp } from "@vue/runtime-dom";
import MainPage from "./pages/MainPage.vue";
import GeneratePage from "./pages/GeneratePage.vue";
import FloatingVue from 'floating-vue';
createApp({})
    .use(FloatingVue)
    .component("main-page", MainPage)
    .component("generate-page", GeneratePage)
    .mount("#app");
